import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import GoogleButton from './GoogleButton';

function retrieveLocalStorage(key) {
  return localStorage.getItem(key);
}

function App() {

  const [accountToken, setAccountToken] = React.useState(retrieveLocalStorage('token'));


  const [carInfo, setCarInfo] = React.useState(null);

  React.useEffect(() => {

    if (accountToken !== null && accountToken.length > 0) {
      fetch('http://localhost:8000/car/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          accountToken: accountToken
        }),
      })
        .then(response => response.json(), () => { alert('Geen toegang!') })
        .then(data => setCarInfo(data));
    }

    localStorage.setItem('token', accountToken);
  }, [accountToken]);


  React.useEffect(() => {
    console.log(carInfo);
  }, [carInfo]);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <GoogleButton accountToken={accountToken} setAccountToken={setAccountToken} />
      </header>
    </div>
  );
}

export default App;
